// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__n5Zny","stat":"style_stat__5GdyZ","statTitle":"style_statTitle__tJqBf","statDescription":"style_statDescription__yBWnv"};